import React from 'react';
import { PROFILE_DATA } from '../data/config';
import { Github, Linkedin, Twitter, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative" style={{ 
      background: 'rgba(20, 12, 8, 0.95)',
      backdropFilter: 'blur(20px)',
      borderTop: '1px solid rgba(255, 232, 200, 0.2)',
      padding: '3rem 0 2rem'
    }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold gradient-text mb-4">
              {PROFILE_DATA.name}
            </h3>
            <p className="text-cream-200" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
              {PROFILE_DATA.title} passionate about automation and creating efficient solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-cream-100 mb-4">Quick Links</h3>
            <div className="space-y-2">
              {['About', 'Experience', 'Projects', 'Contact'].map((link) => (
                <a
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  className="block text-cream-300 hover:text-cream-100 transition-all duration-300"
                  style={{ 
                    fontSize: '0.9rem',
                    transform: 'translateX(0)',
                    display: 'inline-block'
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'translateX(5px)'}
                  onMouseLeave={(e) => e.target.style.transform = 'translateX(0)'}
                >
                  {link}
                </a>
              ))}
            </div>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-lg font-semibold text-cream-100 mb-4">Connect</h3>
            <div className="flex gap-4">
              <a
                href={PROFILE_DATA.social.github}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
                style={{
                  padding: '0.75rem',
                  background: 'rgba(255, 232, 200, 0.1)',
                  borderRadius: '1rem',
                  border: '1px solid rgba(255, 232, 200, 0.2)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.background = 'rgba(255, 232, 200, 0.2)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 232, 200, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.background = 'rgba(255, 232, 200, 0.1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                aria-label="GitHub"
              >
                <Github className="w-5 h-5 text-cream-200 group-hover:text-cream-100" />
              </a>
              <a
                href={PROFILE_DATA.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
                style={{
                  padding: '0.75rem',
                  background: 'rgba(255, 232, 200, 0.1)',
                  borderRadius: '1rem',
                  border: '1px solid rgba(255, 232, 200, 0.2)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.background = 'rgba(255, 232, 200, 0.2)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 232, 200, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.background = 'rgba(255, 232, 200, 0.1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-cream-200 group-hover:text-cream-100" />
              </a>
              <a
                href={PROFILE_DATA.social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
                style={{
                  padding: '0.75rem',
                  background: 'rgba(255, 232, 200, 0.1)',
                  borderRadius: '1rem',
                  border: '1px solid rgba(255, 232, 200, 0.2)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.background = 'rgba(255, 232, 200, 0.2)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 232, 200, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.background = 'rgba(255, 232, 200, 0.1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5 text-cream-200 group-hover:text-cream-100" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ 
          paddingTop: '2rem',
          borderTop: '1px solid rgba(255, 232, 200, 0.15)',
          marginTop: '2rem'
        }}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-cream-300 text-center md:text-left" style={{ fontSize: '0.875rem' }}>
              © {currentYear} {PROFILE_DATA.name}. All rights reserved.
            </p>
            <p className="text-cream-300 flex items-center gap-2" style={{ fontSize: '0.875rem' }}>
              Made with <Heart className="w-4 h-4 text-red-400 fill-current" style={{ animation: 'heartbeat 2s ease-in-out infinite' }} /> and lots of ☕
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
